import React from 'react';
import emptyPage from 'assets/images/icons/empty-page.svg';
import PropTypes from 'prop-types';

export default function EmptyPage({ spiel }) {
  return (
    <div className="h-full flex justify-center items-center text-gray-500">
      <div className="flex flex-col items-center">
        <img src={emptyPage} alt="empty" className="mb-4" />
        <div className="font-bold">Empty</div>
        <div>{spiel}</div>
      </div>
    </div>
  );
}

EmptyPage.defaultProps = {
  spiel: 'There is no selected item.',
};

EmptyPage.propTypes = {
  spiel: PropTypes.string,
};
